import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initConsoleErrorBuffer } from './shared/utils/consoleErrorBuffer';
import { handleInstagramOAuthPopup } from './modules/integrations/lib/instagramLogin';

// Business Login for Instagram: quando ESTA janela é o popup de OAuth do
// Instagram (redirect_uri = a própria origem do app), captura o `?code`,
// posta ao opener e fecha SEM renderizar o app. Roda o mais cedo possível —
// se tratou, aborta o boot (o popup morre em seguida).
if (handleInstagramOAuthPopup()) {
  // eslint-disable-next-line no-console
  console.info('[instagram-oauth] popup de retorno tratado — encerrando janela');
} else {
  bootstrapApp();
}

function bootstrapApp(): void {

// Bootstrap the global console error buffer BEFORE any other error handler is
// attached. The SupportWidget reads this buffer when a user submits a bug
// report so the recent error trail (console.error, window errors, unhandled
// promise rejections) goes in the payload without the user copying logs.
initConsoleErrorBuffer();

// Suppress unhandled promise rejections from third-party scripts (e.g. PostHog feature flags)
window.addEventListener('unhandledrejection', (event) => {
  const msg = String(event.reason?.message || event.reason || '');
  if (msg.includes('payload') || msg.includes('posthog') || msg.includes('feature_flag')) {
    event.preventDefault();
  }
});

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
